export default __webpack_public_path__ + "static/media/links_btn.e1d3df47.jpg";